// Ported verbatim from LC2's VisibilitySwitch.js (commons/components/@extended/) — the
// admin-only toggle shown at the bottom of DaysOnMarket/ConcessionComps that lets a Stake
// admin hide/show a metrics card from the account. Same `updateFeatureVisibility` mutation
// call + optimistic `setVisible`, only the MUI Switch label styling is inline instead of a
// separate stylesheet.
import React from 'react';
import PropTypes from 'prop-types';
import {FormControlLabel, Switch} from '@mui/material';

import {useUpdateFeatureVisibilityMutation} from '../../../features/coreApi/metricsSlice';

const VisibilitySwitch = ({id, accountName, setVisible, isVisible, featureType, modelType}) => {
    const [updateFeatureVisibility] = useUpdateFeatureVisibilityMutation();

    const handleSwitch = (e) => {
        const params = {
            model_type: modelType,
            feature_type: featureType,
            is_visible: e.target.checked,
            sfid: id
        };

        updateFeatureVisibility({...params});
        setVisible(e.target.checked);
    };

    return (
        <FormControlLabel
            control={<Switch color="secondary" checked={isVisible} onChange={handleSwitch} />}
            label={`Display this card to ${accountName}`}
        />
    );
};

VisibilitySwitch.propTypes = {
    id: PropTypes.string,
    accountName: PropTypes.string,
    setVisible: PropTypes.func,
    isVisible: PropTypes.bool,
    featureType: PropTypes.string,
    modelType: PropTypes.string
};

export default VisibilitySwitch;
